import './index.scss';
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-boxes-slider="container"]',
        slider: '[js-boxes-slider="slider"]',
        next: '[js-boxes-slider="next"]',
        prev: '[js-boxes-slider="prev"]',
        pagination: '[js-boxes-slider="pagination"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container);

    if (!containers.length) return;

    containers.forEach((container) => {
        const sliderEl = container.querySelector(nodeSelectors.slider);
        if (!sliderEl) return;

        // Destroy existing swiper instance before re-init
        if (sliderEl.swiper) {
            sliderEl.swiper.destroy(true, true);
        }

        const settings = {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            speed: 300,
            navigation: {
                nextEl: container.querySelector(nodeSelectors.next),
                prevEl: container.querySelector(nodeSelectors.prev),
            },
            pagination: {
                el: container.querySelector(nodeSelectors.pagination),
                clickable: true,
            },
            breakpoints: {
                550: {
                    slidesPerView: 2,
                },
                1100: {
                    slidesPerView: 3,
                },
                1150: {
                    slidesPerView: 4,
                }
            }
        };

        new Swiper(sliderEl, settings);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=boxes-slider', ($block) => {
            const blockEl = $block[0] || $block;

            setTimeout(function() {
                init(blockEl);
            }, 100)
        });
    } else if( !isGutenbergEditorVisible() ) {
        init()
    }
});